/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Out_Action_Create_Sorting_PnkInputs */

const vi_pl_out_action_create_sorting_pnk = /** @type {(inputs: Pl_Out_Action_Create_Sorting_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu nhập kho phân loại`)
};

/**

* @param {Pl_Out_Action_Create_Sorting_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_out_action_create_sorting_pnk = /** @type {((inputs?: Pl_Out_Action_Create_Sorting_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Out_Action_Create_Sorting_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_out_action_create_sorting_pnk(inputs)
});